import { Link } from '@change/ds-core-ui/next';

import { usePageFooter } from './hooks/usePageFooter';

export function PageFooter() {
	const {
		data: { skipLabel, skipUrl },
		actions: { handleSkipClick },
	} = usePageFooter();

	return (
		<div className="mt-16 text-center">
			<Link href={skipUrl} onClick={handleSkipClick} data-qa="skip-link" size="large" bold>
				{skipLabel}
			</Link>
		</div>
	);
}
